import { AnnotationSourceReference, RunnitNodeRunResult, RunnitUpload } from '@run-diffusion/shared';

/** 3D assets and layered results are not supported, even when they have a preview. */
export const canAnnotateImage = (image: RunnitNodeRunResult | RunnitUpload | null | undefined): boolean => image?.type === 'IMG';

/** IMG results use their file, never a layered download or 3D thumbnail. */
export const annotationSourceReference = (
	image: RunnitNodeRunResult | RunnitUpload,
	useCase: 'nodeRunResult' | 'upload',
): AnnotationSourceReference | null => {
	if (!canAnnotateImage(image)) return null;
	if (useCase === 'upload') return { kind: 'upload', uploadId: (image as RunnitUpload).id };
	const result = image as RunnitNodeRunResult;
	return {
		kind: 'result', nodeRunId: result.nodeRunId, resultUuid: result.uuid,
		variant: 'file',
	};
};
